var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelete = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none",
    viewBox: "0 0 17 17",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    fillRule: "evenodd",
    d: "M8.227 16.864a8 8 0 1 0 0-16 8 8 0 0 0 0 16M5.492 5.598a.375.375 0 0 0-.53.53l2.735 2.736-2.735 2.734a.375.375 0 1 0 .53.53l2.735-2.734 2.735 2.735a.375.375 0 1 0 .53-.53L8.759 8.864l2.735-2.735a.375.375 0 0 0-.53-.53L8.226 8.332z",
    clipRule: "evenodd"
  })));
};
export default SvgDelete;